{
  "account.delete-confirm": [
    {
      "type": 0,
      "value": "Delete Account"
    }
  ],
  "account.delete-confirmation-instruction": [
    {
      "type": 0,
      "value": "Please type DELETE MY ACCOUNT to confirm:"
    }
  ],
  "account.delete-confirmation-title": [
    {
      "type": 0,
      "value": "Are you absolutely sure?"
    }
  ],
  "account.delete-confirmation-warning": [
    {
      "type": 0,
      "value": "This action cannot be undone. This will permanently delete your account and remove all data from our servers."
    }
  ],
  "account.delete-warning": [
    {
      "type": 0,
      "value": "Keep in mind that you will not be able retrieve any mindmap you have added. All your information will be deleted and it can not be restored."
    }
  ],
  "account.delete-warning-collaborations": [
    {
      "type": 0,
      "value": "All shared mindmaps and collaborations"
    }
  ],
  "account.delete-warning-consequences": [
    {
      "type": 0,
      "value": "This will permanently delete:"
    }
  ],
  "account.delete-warning-data": [
    {
      "type": 0,
      "value": "All your personal data and account information"
    }
  ],
  "account.delete-warning-description": [
    {
      "type": 0,
      "value": "Once you delete your account, there is no going back. Please be certain."
    }
  ],
  "account.delete-warning-history": [
    {
      "type": 0,
      "value": "All account history and activity logs"
    }
  ],
  "account.delete-warning-mindmaps": [
    {
      "type": 0,
      "value": "All your mindmaps and their content"
    }
  ],
  "account.delete-warning-title": [
    {
      "type": 0,
      "value": "Delete Account"
    }
  ],
  "accountinfo.button": [
    {
      "type": 0,
      "value": "Accept"
    }
  ],
  "accountinfo.deleteaccount": [
    {
      "type": 0,
      "value": "Delete Account"
    }
  ],
  "accountinfo.email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "accountinfo.firstname": [
    {
      "type": 0,
      "value": "First Name"
    }
  ],
  "accountinfo.lastname": [
    {
      "type": 0,
      "value": "Last Name"
    }
  ],
  "accountinfo.personal-details": [
    {
      "type": 0,
      "value": "Personal Details"
    }
  ],
  "accountinfo.title": [
    {
      "type": 0,
      "value": "Account info"
    }
  ],
  "action.cancel-button": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "action.close-button": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "action.delete": [
    {
      "type": 0,
      "value": "Delete"
    }
  ],
  "action.delete-description": [
    {
      "type": 0,
      "value": "Deleted mindmap can not be recovered. Do you want to continue ?."
    }
  ],
  "action.delete-title": [
    {
      "type": 0,
      "value": "Delete"
    }
  ],
  "action.duplicate": [
    {
      "type": 0,
      "value": "Duplicate"
    }
  ],
  "action.export": [
    {
      "type": 0,
      "value": "Export"
    }
  ],
  "action.history": [
    {
      "type": 0,
      "value": "History"
    }
  ],
  "action.history-description": [
    {
      "type": 0,
      "value": "List of changes introduced in the last 90 days."
    }
  ],
  "action.history-title": [
    {
      "type": 0,
      "value": "Version history"
    }
  ],
  "action.import": [
    {
      "type": 0,
      "value": "Import"
    }
  ],
  "action.info": [
    {
      "type": 0,
      "value": "Info"
    }
  ],
  "action.label": [
    {
      "type": 0,
      "value": "Add Label"
    }
  ],
  "action.new": [
    {
      "type": 0,
      "value": "New map"
    }
  ],
  "action.open": [
    {
      "type": 0,
      "value": "Open"
    }
  ],
  "action.print": [
    {
      "type": 0,
      "value": "Print"
    }
  ],
  "action.publish": [
    {
      "type": 0,
      "value": "Publish"
    }
  ],
  "action.rename": [
    {
      "type": 0,
      "value": "Rename"
    }
  ],
  "action.rename-description-placeholder": [
    {
      "type": 0,
      "value": "Description"
    }
  ],
  "action.rename-name-placeholder": [
    {
      "type": 0,
      "value": "Name"
    }
  ],
  "action.share": [
    {
      "type": 0,
      "value": "Share"
    }
  ],
  "activation.error.message": [
    {
      "type": 0,
      "value": "We couldn't activate your account. The activation link may be invalid or expired. Please contact support for assistance."
    }
  ],
  "activation.error.title": [
    {
      "type": 0,
      "value": "Activation Failed"
    }
  ],
  "activation.loading.desc": [
    {
      "type": 0,
      "value": "Please wait while we activate your account..."
    }
  ],
  "activation.loading.title": [
    {
      "type": 0,
      "value": "Activating Your Account"
    }
  ],
  "activation.success.message": [
    {
      "type": 0,
      "value": "Your account has been activated. You can now sign in and start creating mind maps."
    }
  ],
  "activation.success.title": [
    {
      "type": 0,
      "value": "Account Activated Successfully"
    }
  ],
  "admin.auth-type": [
    {
      "type": 0,
      "value": "Auth Type"
    }
  ],
  "admin.change-password": [
    {
      "type": 0,
      "value": "Change password"
    }
  ],
  "admin.change-password-button": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "admin.change-password-description": [
    {
      "type": 0,
      "value": "Change password for user: "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "admin.change-password-title": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "admin.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "admin.confirm-password": [
    {
      "type": 0,
      "value": "Confirm Password"
    }
  ],
  "admin.delete": [
    {
      "type": 0,
      "value": "Delete"
    }
  ],
  "admin.delete-user": [
    {
      "type": 0,
      "value": "Delete user"
    }
  ],
  "admin.edit": [
    {
      "type": 0,
      "value": "Edit"
    }
  ],
  "admin.edit-user": [
    {
      "type": 0,
      "value": "Edit user"
    }
  ],
  "admin.lock-status": [
    {
      "type": 0,
      "value": "Lock Status"
    }
  ],
  "admin.locked": [
    {
      "type": 0,
      "value": "Locked"
    }
  ],
  "admin.new-password": [
    {
      "type": 0,
      "value": "New Password"
    }
  ],
  "admin.password-error-facebook": [
    {
      "type": 0,
      "value": "This user is authenticated via Facebook. Password changes are not available for Facebook accounts. Please ask the user to manage their password through their Facebook account."
    }
  ],
  "admin.password-error-failed": [
    {
      "type": 0,
      "value": "Failed to change password"
    }
  ],
  "admin.password-error-google": [
    {
      "type": 0,
      "value": "This user is authenticated via Google. Password changes are not available for Google accounts. Please ask the user to manage their password through their Google account."
    }
  ],
  "admin.password-error-length": [
    {
      "type": 0,
      "value": "Password must be at least 6 characters"
    }
  ],
  "admin.password-error-mismatch": [
    {
      "type": 0,
      "value": "Passwords do not match"
    }
  ],
  "admin.public": [
    {
      "type": 0,
      "value": "Public"
    }
  ],
  "admin.public-access": [
    {
      "type": 0,
      "value": "Public Access"
    }
  ],
  "admin.refresh": [
    {
      "type": 0,
      "value": "Refresh"
    }
  ],
  "admin.status": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "admin.status-active": [
    {
      "type": 0,
      "value": "Active"
    }
  ],
  "admin.status-clean": [
    {
      "type": 0,
      "value": "Clean"
    }
  ],
  "admin.status-suspended": [
    {
      "type": 0,
      "value": "Suspended"
    }
  ],
  "admin.suspend-user": [
    {
      "type": 0,
      "value": "Suspend user"
    }
  ],
  "admin.suspension-reason": [
    {
      "type": 0,
      "value": "Suspension Reason"
    }
  ],
  "admin.suspension-status": [
    {
      "type": 0,
      "value": "Suspension Status"
    }
  ],
  "admin.suspension.abuse": [
    {
      "type": 0,
      "value": "Abuse"
    }
  ],
  "admin.suspension.inactivity": [
    {
      "type": 0,
      "value": "Inactivity"
    }
  ],
  "admin.suspension.manual-review": [
    {
      "type": 0,
      "value": "Manual Review"
    }
  ],
  "admin.suspension.other": [
    {
      "type": 0,
      "value": "Other"
    }
  ],
  "admin.suspension.security-concern": [
    {
      "type": 0,
      "value": "Security Concern"
    }
  ],
  "admin.suspension.terms-violation": [
    {
      "type": 0,
      "value": "Terms Violation"
    }
  ],
  "admin.system.db.url": [
    {
      "type": 0,
      "value": "URL"
    }
  ],
  "admin.system.jvm": [
    {
      "type": 0,
      "value": "JVM"
    }
  ],
  "admin.system.memory": [
    {
      "type": 0,
      "value": "Memory"
    }
  ],
  "admin.system.refresh": [
    {
      "type": 0,
      "value": "Refresh"
    }
  ],
  "admin.system.title": [
    {
      "type": 0,
      "value": "System Information"
    }
  ],
  "admin.unsuspend-user": [
    {
      "type": 0,
      "value": "Unsuspend user"
    }
  ],
  "admin.view-xml": [
    {
      "type": 0,
      "value": "View XML"
    }
  ],
  "changepwd.confirm-password": [
    {
      "type": 0,
      "value": "Confirm Password"
    }
  ],
  "changepwd.description": [
    {
      "type": 0,
      "value": "Please, provide the new password for your account."
    }
  ],
  "changepwd.password": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "changepwd.password-match": [
    {
      "type": 0,
      "value": "Password do not match. Please, try again."
    }
  ],
  "changepwd.title": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "common.allow-email-notifications": [
    {
      "type": 0,
      "value": "Allow Email Notifications"
    }
  ],
  "common.delete": [
    {
      "type": 0,
      "value": "Delete"
    }
  ],
  "common.delete-tag": [
    {
      "type": 0,
      "value": "Delete tag"
    }
  ],
  "common.email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "common.emails": [
    {
      "type": 0,
      "value": "Emails"
    }
  ],
  "common.first-name": [
    {
      "type": 0,
      "value": "First Name"
    }
  ],
  "common.last-name": [
    {
      "type": 0,
      "value": "Last Name"
    }
  ],
  "common.loading": [
    {
      "type": 0,
      "value": "Loading..."
    }
  ],
  "common.locale": [
    {
      "type": 0,
      "value": "Locale"
    }
  ],
  "common.login-form": [
    {
      "type": 0,
      "value": "Login form"
    }
  ],
  "common.maps-list": [
    {
      "type": 0,
      "value": "Maps list"
    }
  ],
  "common.open-drawer": [
    {
      "type": 0,
      "value": "Open drawer"
    }
  ],
  "common.others": [
    {
      "type": 0,
      "value": "Others"
    }
  ],
  "common.refresh": [
    {
      "type": 0,
      "value": "Refresh"
    }
  ],
  "common.registration-form": [
    {
      "type": 0,
      "value": "Registration form"
    }
  ],
  "common.retry": [
    {
      "type": 0,
      "value": "Retry"
    }
  ],
  "common.settings": [
    {
      "type": 0,
      "value": "Settings"
    }
  ],
  "common.terms-notice": [
    {
      "type": 0,
      "value": "By continuing, you agree to our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Terms of Service"
        }
      ],
      "type": 8,
      "value": "termsLink"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Privacy Policy"
        }
      ],
      "type": 8,
      "value": "privacyLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "common.wait": [
    {
      "type": 0,
      "value": "Please wait ..."
    }
  ],
  "create.button": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "create.description": [
    {
      "type": 0,
      "value": "Please, fill the new map name and description."
    }
  ],
  "create.title": [
    {
      "type": 0,
      "value": "Create a new mindmap"
    }
  ],
  "deletem.title": [
    {
      "type": 0,
      "value": "All selected maps will be deleted"
    }
  ],
  "dialog.loading": [
    {
      "type": 0,
      "value": "Loading ..."
    }
  ],
  "duplicate.copy-prefix": [
    {
      "type": 0,
      "value": "Copy of "
    }
  ],
  "duplicate.title": [
    {
      "type": 0,
      "value": "Duplicate"
    }
  ],
  "error.contact-support": [
    {
      "type": 0,
      "value": "Need help? Contact us at "
    },
    {
      "type": 1,
      "value": "support"
    }
  ],
  "error.generic-message": [
    {
      "type": 0,
      "value": "Please try again later or contact support if the problem continues."
    }
  ],
  "error.generic-title": [
    {
      "type": 0,
      "value": "Hmm, that didn't work."
    }
  ],
  "error.go-back": [
    {
      "type": 0,
      "value": "Go Back"
    }
  ],
  "error.go-home": [
    {
      "type": 0,
      "value": "Go to Home"
    }
  ],
  "error.go-to-login": [
    {
      "type": 0,
      "value": "Sign In"
    }
  ],
  "error.map-title-required": [
    {
      "type": 0,
      "value": "Map title is required and cannot be empty"
    }
  ],
  "error.map-unavailable-message": [
    {
      "type": 0,
      "value": "This mindmap is not available for public display because it violates our site policies. If you need further assistance, contact support@wisemapping.com."
    }
  ],
  "error.map-unavailable-title": [
    {
      "type": 0,
      "value": "This mindmap is not available for public display."
    }
  ],
  "error.not-found-message": [
    {
      "type": 0,
      "value": "The page you're looking for might have been removed, had its name changed, or is temporarily unavailable."
    }
  ],
  "error.not-found-title": [
    {
      "type": 0,
      "value": "We can't find that page."
    }
  ],
  "error.page-title": [
    {
      "type": 0,
      "value": "Unexpected Error | WiseMapping"
    }
  ],
  "error.permission-denied-message": [
    {
      "type": 0,
      "value": "If you believe you should have access, please contact your administrator."
    }
  ],
  "error.permission-denied-title": [
    {
      "type": 0,
      "value": "You don't have access to this page."
    }
  ],
  "expired.description": [
    {
      "type": 0,
      "value": "Your current session has expired. Please, sign in and try again."
    }
  ],
  "expired.title": [
    {
      "type": 0,
      "value": "Your session has expired"
    }
  ],
  "export.desc": [
    {
      "type": 0,
      "value": "Export this map in the format that you want and start using it in your presentations or sharing by email"
    }
  ],
  "export.document": [
    {
      "type": 0,
      "value": "Mindmap Tools: Export your mindmap in thirdparty mindmap tool formats"
    }
  ],
  "export.document-label": [
    {
      "type": 0,
      "value": "Document: Export your mindmap in a self-contained document ready to share"
    }
  ],
  "export.image": [
    {
      "type": 0,
      "value": "Image: Get a graphic representation of your map including all colors and shapes."
    }
  ],
  "export.img-center": [
    {
      "type": 0,
      "value": "Center and zoom to fit"
    }
  ],
  "export.title": [
    {
      "type": 0,
      "value": "Export"
    }
  ],
  "export.warning": [
    {
      "type": 0,
      "value": "Exporting to Image (SVG,PNG,JPEG,PDF) is only available in the editor toolbar."
    }
  ],
  "footer.aboutus": [
    {
      "type": 0,
      "value": "About Us"
    }
  ],
  "footer.col-community": [
    {
      "type": 0,
      "value": "Community"
    }
  ],
  "footer.col-company": [
    {
      "type": 0,
      "value": "Company"
    }
  ],
  "footer.col-support": [
    {
      "type": 0,
      "value": "Support"
    }
  ],
  "footer.contactus": [
    {
      "type": 0,
      "value": "Contact Us"
    }
  ],
  "footer.copyright": [
    {
      "type": 0,
      "value": "© "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " WiseMapping LLC"
    }
  ],
  "footer.donations": [
    {
      "type": 0,
      "value": "Donations"
    }
  ],
  "footer.faq": [
    {
      "type": 0,
      "value": "F.A.Q."
    }
  ],
  "footer.feedback": [
    {
      "type": 0,
      "value": "Feedback"
    }
  ],
  "footer.news": [
    {
      "type": 0,
      "value": "News"
    }
  ],
  "footer.opensource": [
    {
      "type": 0,
      "value": "Open Source"
    }
  ],
  "footer.privacypolicy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "footer.termsandconditions": [
    {
      "type": 0,
      "value": "Term And Conditions"
    }
  ],
  "footer.twitter": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "forgot.desc": [
    {
      "type": 0,
      "value": "We will send you an email to reset your password."
    }
  ],
  "forgot.email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "forgot.oauth.back": [
    {
      "type": 0,
      "value": "Back to login"
    }
  ],
  "forgot.oauth.message": [
    {
      "type": 0,
      "value": "You dont need password, please login using Facebook or Google."
    }
  ],
  "forgot.page-title": [
    {
      "type": 0,
      "value": "Forgot Password | WiseMapping"
    }
  ],
  "forgot.register": [
    {
      "type": 0,
      "value": "Send recovery link"
    }
  ],
  "forgot.success.desc": [
    {
      "type": 0,
      "value": "We've sent a password reset link to your email. The link expires in 1 hour. Your current password remains unchanged until you use the link."
    }
  ],
  "forgot.success.title": [
    {
      "type": 0,
      "value": "Check your email."
    }
  ],
  "forgot.title": [
    {
      "type": 0,
      "value": "Reset your password"
    }
  ],
  "forgotsuccess.page-title": [
    {
      "type": 0,
      "value": "Password Recovered | WiseMapping"
    }
  ],
  "header.donthaveaccount": [
    {
      "type": 0,
      "value": "Don't have an account ?"
    }
  ],
  "header.haveaccount": [
    {
      "type": 0,
      "value": "Already have an account?"
    }
  ],
  "help.support": [
    {
      "type": 0,
      "value": "Support"
    }
  ],
  "history.no-changes": [
    {
      "type": 0,
      "value": "There is no changes available"
    }
  ],
  "import.button": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "import.description": [
    {
      "type": 0,
      "value": "You can import WiseMapping, FreeMind, Freeplane, XMind, MindManager, and OPML maps to your list of maps. Select the file you want to import."
    }
  ],
  "import.error-file": [
    {
      "type": 0,
      "value": "Import error "
    },
    {
      "type": 1,
      "value": "error"
    }
  ],
  "import.title": [
    {
      "type": 0,
      "value": "Import existing mindmap"
    }
  ],
  "info.basic-info": [
    {
      "type": 0,
      "value": "Basic Info"
    }
  ],
  "info.button": [
    {
      "type": 0,
      "value": "Accept"
    }
  ],
  "info.creation-time": [
    {
      "type": 0,
      "value": "Creation Date"
    }
  ],
  "info.creator": [
    {
      "type": 0,
      "value": "Creator"
    }
  ],
  "info.description": [
    {
      "type": 0,
      "value": "Description"
    }
  ],
  "info.description-msg": [
    {
      "type": 0,
      "value": "By publishing the map you make it visible to everyone on the Internet."
    }
  ],
  "info.modified-time": [
    {
      "type": 0,
      "value": "Last Modified Date"
    }
  ],
  "info.modified-tny": [
    {
      "type": 0,
      "value": "Last Modified By"
    }
  ],
  "info.name": [
    {
      "type": 0,
      "value": "Name"
    }
  ],
  "info.public-visibility": [
    {
      "type": 0,
      "value": "Publicly Visible"
    }
  ],
  "info.sharing": [
    {
      "type": 0,
      "value": "Sharing"
    }
  ],
  "info.starred": [
    {
      "type": 0,
      "value": "Starred"
    }
  ],
  "info.title": [
    {
      "type": 0,
      "value": "Info"
    }
  ],
  "label.add-button": [
    {
      "type": 0,
      "value": "Add label"
    }
  ],
  "label.add-for": [
    {
      "type": 0,
      "value": "Editing labels for"
    }
  ],
  "label.add-placeholder": [
    {
      "type": 0,
      "value": "Label title"
    }
  ],
  "label.change-color": [
    {
      "type": 0,
      "value": "Change label color"
    }
  ],
  "label.delete-description": [
    {
      "type": 0,
      "value": "will be deleted, including its associations to all existing maps. Do you want to continue?"
    }
  ],
  "label.delete-title": [
    {
      "type": 0,
      "value": "Confirm label deletion"
    }
  ],
  "label.description": [
    {
      "type": 0,
      "value": "Use labels to organize your maps."
    }
  ],
  "label.maps-count": [
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " maps"
    }
  ],
  "label.title": [
    {
      "type": 0,
      "value": "Add a label"
    }
  ],
  "language.change": [
    {
      "type": 0,
      "value": "Change Language"
    }
  ],
  "language.help": [
    {
      "type": 0,
      "value": "Help to Translate"
    }
  ],
  "login.desc": [
    {
      "type": 0,
      "value": "Log into your account"
    }
  ],
  "login.division": [
    {
      "type": 0,
      "value": "or"
    }
  ],
  "login.email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "login.error": [
    {
      "type": 0,
      "value": "The email address or password you entered is not valid."
    }
  ],
  "login.facebook.button": [
    {
      "type": 0,
      "value": "Sign in with Facebook"
    }
  ],
  "login.forgotpwd": [
    {
      "type": 0,
      "value": "Forgot Password ?"
    }
  ],
  "login.generic-error": [
    {
      "type": 0,
      "value": "An error occurred during authentication. Please try again."
    }
  ],
  "login.google.button": [
    {
      "type": 0,
      "value": "Sign in with Google"
    }
  ],
  "login.oauth-error": [
    {
      "type": 0,
      "value": "OAuth authentication failed. Please try again or use a different sign-in method."
    }
  ],
  "login.page-title": [
    {
      "type": 0,
      "value": "Login | WiseMapping"
    }
  ],
  "login.password": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "login.redirecting": [
    {
      "type": 0,
      "value": "Redirecting..."
    }
  ],
  "login.server-error": [
    {
      "type": 0,
      "value": "An unexpected error occurred. Please try again later."
    }
  ],
  "login.shared-map-notice": [
    {
      "type": 0,
      "value": "A mind map has been shared with you. Please log in to access it. Don't have an account? Sign up for free or use your Google/Facebook account."
    }
  ],
  "login.signin": [
    {
      "type": 0,
      "value": "Sign In"
    }
  ],
  "login.signup": [
    {
      "type": 0,
      "value": "Sign Up"
    }
  ],
  "login.title": [
    {
      "type": 0,
      "value": "Welcome"
    }
  ],
  "map.creator": [
    {
      "type": 0,
      "value": "Creator"
    }
  ],
  "map.delete-selected": [
    {
      "type": 0,
      "value": "Delete selected"
    }
  ],
  "map.last-update": [
    {
      "type": 0,
      "value": "Last Update"
    }
  ],
  "map.more-actions": [
    {
      "type": 0,
      "value": "More Actions"
    }
  ],
  "map.name": [
    {
      "type": 0,
      "value": "Name"
    }
  ],
  "map.tooltip-add": [
    {
      "type": 0,
      "value": "Add label to selected"
    }
  ],
  "maps.auth-required-default-message": [
    {
      "type": 0,
      "value": "You need to sign in to view your maps."
    }
  ],
  "maps.auth-required-heading": [
    {
      "type": 0,
      "value": "Sign in to access your maps"
    }
  ],
  "maps.auth-required-login": [
    {
      "type": 0,
      "value": "Go to login"
    }
  ],
  "maps.auth-required-title": [
    {
      "type": 0,
      "value": "Sign In Required | WiseMapping"
    }
  ],
  "maps.choose-file": [
    {
      "type": 0,
      "value": "Choose a file"
    }
  ],
  "maps.copilot-button": [
    {
      "type": 0,
      "value": "AI Copilot"
    }
  ],
  "maps.copilot-dialog.continue": [
    {
      "type": 0,
      "value": "Open Copilot"
    }
  ],
  "maps.copilot-dialog.description": [
    {
      "type": 0,
      "value": "ChatGPT-powered AI Copilot is a brainstorming assistant that turns your prompts into structured mind maps. We'll open it in a new tab so you can expand ideas, generate topics, and bring the best ones back to WiseMapping."
    }
  ],
  "maps.copilot-dialog.title": [
    {
      "type": 0,
      "value": "ChatGPT-powered Mindmap Copilot"
    }
  ],
  "maps.copilot-tooltip": [
    {
      "type": 0,
      "value": "Start a mindmap with ChatGPT-powered AI Copilot"
    }
  ],
  "maps.create-tooltip": [
    {
      "type": 0,
      "value": "Create a new mindmap"
    }
  ],
  "maps.empty-result": [
    {
      "type": 0,
      "value": "No matching mindmap found with the current filter criteria."
    }
  ],
  "maps.import-desc": [
    {
      "type": 0,
      "value": "Import from other tools"
    }
  ],
  "maps.modified": [
    {
      "type": 0,
      "value": "Modified"
    }
  ],
  "maps.modified-by": [
    {
      "type": 0,
      "value": "Modified By"
    }
  ],
  "maps.modified-by-desc": [
    {
      "type": 0,
      "value": "Modified by "
    },
    {
      "type": 1,
      "value": "by"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "on"
    }
  ],
  "maps.nav-all": [
    {
      "type": 0,
      "value": "All"
    }
  ],
  "maps.nav-onwned": [
    {
      "type": 0,
      "value": "Owned"
    }
  ],
  "maps.nav-public": [
    {
      "type": 0,
      "value": "Public"
    }
  ],
  "maps.nav-shared": [
    {
      "type": 0,
      "value": "Shared with me"
    }
  ],
  "maps.nav-starred": [
    {
      "type": 0,
      "value": "Starred"
    }
  ],
  "maps.page-title": [
    {
      "type": 0,
      "value": "My Maps | WiseMapping"
    }
  ],
  "maps.revert": [
    {
      "type": 0,
      "value": "Revert"
    }
  ],
  "maps.search-action": [
    {
      "type": 0,
      "value": "Search ..."
    }
  ],
  "maps.tooltip-open": [
    {
      "type": 0,
      "value": "Open for edition"
    }
  ],
  "maps.tooltip-starred": [
    {
      "type": 0,
      "value": "Starred"
    }
  ],
  "maps.view": [
    {
      "type": 0,
      "value": "View"
    }
  ],
  "menu.account": [
    {
      "type": 0,
      "value": "Account"
    }
  ],
  "menu.admin-console": [
    {
      "type": 0,
      "value": "Admin Console"
    }
  ],
  "menu.change-password": [
    {
      "type": 0,
      "value": "Change password"
    }
  ],
  "menu.signout": [
    {
      "type": 0,
      "value": "Sign Out"
    }
  ],
  "publish.checkbox": [
    {
      "type": 0,
      "value": "Enable public sharing"
    }
  ],
  "publish.copied": [
    {
      "type": 0,
      "value": "Copied to clipboard!"
    }
  ],
  "publish.description": [
    {
      "type": 0,
      "value": "Make your map public. Anyone with the link can view it."
    }
  ],
  "publish.embedded": [
    {
      "type": 0,
      "value": "Embedded"
    }
  ],
  "publish.embedded-msg": [
    {
      "type": 0,
      "value": "Click the code below to copy it to your clipboard:"
    }
  ],
  "publish.public-url": [
    {
      "type": 0,
      "value": "Public URL"
    }
  ],
  "publish.public-url-msg": [
    {
      "type": 0,
      "value": "Click the link below to copy it to your clipboard:"
    }
  ],
  "publish.title": [
    {
      "type": 0,
      "value": "Publish"
    }
  ],
  "registation.success-title": [
    {
      "type": 0,
      "value": "Registation Success | WiseMapping"
    }
  ],
  "registration.callback.back": [
    {
      "type": 0,
      "value": "Back to login"
    }
  ],
  "registration.callback.confirm.description": [
    {
      "type": 0,
      "value": "An account with the same email was previously registered. Do you want to link your "
    },
    {
      "type": 1,
      "value": "provider"
    },
    {
      "type": 0,
      "value": " account to that WiseMapping account?"
    }
  ],
  "registration.callback.confirm.title": [
    {
      "type": 0,
      "value": "Confirm"
    }
  ],
  "registration.callback.sync": [
    {
      "type": 0,
      "value": "Sync account"
    }
  ],
  "registration.callback.waiting.description": [
    {
      "type": 0,
      "value": "Please wait while we validate your identity"
    }
  ],
  "registration.callback.waiting.title": [
    {
      "type": 0,
      "value": "Finishing..."
    }
  ],
  "registration.desc": [
    {
      "type": 0,
      "value": "Signing up is free and just take a moment"
    }
  ],
  "registration.division": [
    {
      "type": 0,
      "value": "or"
    }
  ],
  "registration.email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "registration.error.title": [
    {
      "type": 0,
      "value": "Registration Failed"
    }
  ],
  "registration.facebook.button": [
    {
      "type": 0,
      "value": "Sign up with Facebook"
    }
  ],
  "registration.firstname": [
    {
      "type": 0,
      "value": "First Name"
    }
  ],
  "registration.form-legend": [
    {
      "type": 0,
      "value": "Account Information"
    }
  ],
  "registration.google.button": [
    {
      "type": 0,
      "value": "Sign up with Google"
    }
  ],
  "registration.lastname": [
    {
      "type": 0,
      "value": "Last Name"
    }
  ],
  "registration.page-title": [
    {
      "type": 0,
      "value": "Registration | WiseMapping"
    }
  ],
  "registration.password": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "registration.recaptcha-notice": [
    {
      "type": 0,
      "value": "This site is protected by reCAPTCHA and the Google "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Privacy Policy"
        }
      ],
      "type": 8,
      "value": "privacyLink"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Terms of Service"
        }
      ],
      "type": 8,
      "value": "termsLink"
    },
    {
      "type": 0,
      "value": " apply."
    }
  ],
  "registration.register": [
    {
      "type": 0,
      "value": "Register"
    }
  ],
  "registration.success.already-activated": [
    {
      "type": 0,
      "value": "Already activated your account?"
    }
  ],
  "registration.success.check-spam": [
    {
      "type": 0,
      "value": "If you don't see the email, please check your spam folder."
    }
  ],
  "registration.success.email-sent": [
    {
      "type": 0,
      "value": "We've sent an activation email to your inbox. Please check your email and click on the activation link to activate your account."
    }
  ],
  "registration.success.title": [
    {
      "type": 0,
      "value": "Registration Successful!"
    }
  ],
  "registration.title": [
    {
      "type": 0,
      "value": "Become a member"
    }
  ],
  "rename.description": [
    {
      "type": 0,
      "value": "Please, fill the new map name and description."
    }
  ],
  "rename.title": [
    {
      "type": 0,
      "value": "Rename"
    }
  ],
  "reset-password.confirm-password": [
    {
      "type": 0,
      "value": "Confirm new password"
    }
  ],
  "reset-password.desc": [
    {
      "type": 0,
      "value": "Enter your new password below."
    }
  ],
  "reset-password.invalid-link": [
    {
      "type": 0,
      "value": "Invalid password reset link. Please request a new one."
    }
  ],
  "reset-password.mismatch": [
    {
      "type": 0,
      "value": "Passwords do not match."
    }
  ],
  "reset-password.page-title": [
    {
      "type": 0,
      "value": "Reset Password | WiseMapping"
    }
  ],
  "reset-password.password": [
    {
      "type": 0,
      "value": "New password"
    }
  ],
  "reset-password.request-new": [
    {
      "type": 0,
      "value": "Request new link"
    }
  ],
  "reset-password.submit": [
    {
      "type": 0,
      "value": "Set new password"
    }
  ],
  "reset-password.title": [
    {
      "type": 0,
      "value": "Set a new password"
    }
  ],
  "reset-password.too-long": [
    {
      "type": 0,
      "value": "Password must be less than 40 characters."
    }
  ],
  "reset-password.too-short": [
    {
      "type": 0,
      "value": "Password must be at least 8 characters."
    }
  ],
  "role.editor": [
    {
      "type": 0,
      "value": "Editor"
    }
  ],
  "role.owner": [
    {
      "type": 0,
      "value": "Owner"
    }
  ],
  "role.viewer": [
    {
      "type": 0,
      "value": "Viewer"
    }
  ],
  "share.add-button": [
    {
      "type": 0,
      "value": "Share"
    }
  ],
  "share.add-message": [
    {
      "type": 0,
      "value": "Add message"
    }
  ],
  "share.adding-button": [
    {
      "type": 0,
      "value": "Sharing..."
    }
  ],
  "share.can-edit": [
    {
      "type": 0,
      "value": "Can edit"
    }
  ],
  "share.delete": [
    {
      "type": 0,
      "value": "Delete collaborator"
    }
  ],
  "share.delete-description": [
    {
      "type": 0,
      "value": "Add collaborators. They'll get instant email access to edit together."
    }
  ],
  "share.delete-title": [
    {
      "type": 0,
      "value": "Share with people"
    }
  ],
  "share.message": [
    {
      "type": 0,
      "value": "Message"
    }
  ],
  "share.table.actions": [
    {
      "type": 0,
      "value": "Actions"
    }
  ],
  "share.table.collaborator": [
    {
      "type": 0,
      "value": "Collaborator"
    }
  ],
  "share.table.role": [
    {
      "type": 0,
      "value": "Role"
    }
  ],
  "theme.dark": [
    {
      "type": 0,
      "value": "Dark"
    }
  ],
  "theme.light": [
    {
      "type": 0,
      "value": "Light"
    }
  ],
  "theme.toggle": [
    {
      "type": 0,
      "value": "Toggle Theme"
    }
  ],
  "validation.title-required": [
    {
      "type": 0,
      "value": "Title is required"
    }
  ]
}
